export default __webpack_public_path__ + "static/brand-style-guide@2x-0c225a6352e9362267ed900b1e0e8092.png";